import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderBottom from './../../components/HomePage/HeaderBottom';

const FooterCopyright = () => {

    const [footercopyright, setFooterCopyright] = useState([]);

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/copyrights`)
            .then((res) => res.json())
            .then((info) => setFooterCopyright(info));
    }, []);

    const handleFooterCopyright = (event) => {
        event.preventDefault();
        const copyrightText = event.target.copyrightText.value;

        const FooterCopyrightSection = {
            copyrightText,
        };

        const url = `https://aprilone-178ea8362c0b.herokuapp.com/add-footer-copyright`;
        fetch(url, {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(FooterCopyrightSection),
        })
            .then((res) => res.json())
            .then((result) => {
                alert('Footer Copy Right Updated');
            });
    };

    return (
        <>
        <HeaderBottom></HeaderBottom>
            
            <section id="services" className="services-area  d-flex align-items-center justify-content-center">
                <div className="container text-center">
                    <div className="row justify-content-center vh-100">
                        <div className="col-lg-8 col-md-12">
                        <h2 className="mb-4 text-center">Update Footer Copyright</h2>
                            {
                                footercopyright.length === 1 &&
                                <div className="mb-4">
                                    {
                                        footercopyright.map(c => (
                                            <Link key={c._id} className='button-professional d-inline-block mx-auto' to={`/edit-copyright/${c._id}`}>Please Edit About Footer</Link>
                                        ))
                                    }
                                </div>
                            }
                            {
                                footercopyright.length === 0 &&
                                <form className="contact-form text-center" onSubmit={handleFooterCopyright}>
                                    <div className="form-group mb-3">
                                        <input type="text" className="form-control mx-auto " id="firstn" name="copyrightText" placeholder="Copyright Text" required />
                                    </div>
                                    <div className="text-center">
                                        <button type="submit" className="button-professional">Update Footer Copyright</button>
                                    </div>
                                </form>
                            }
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FooterCopyright;
